import React, { ReactNode, useEffect, useState } from 'react';
import {
  getInitialValueByName,
  initialValues,
  socialLinksName,
  socialLinksSchema,
  socialLinkType
} from '@/dealerProfile/edit-dealer-profile/schemas';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch
} from '@chakra-ui/react';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '@/common/form/TextField';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import {
  callToCreateDealerAction,
  setIsCreateDealerActionCompleted,
  setIsCreateDealerActionInprogress
} from '@/explore/ducks/slice';
//icons
import GoogleIcon from '../../common/images/socials/google.svg';
import FacebookIcon from '../../common/images/socials/facebook.svg';
import TwitterIcon from '../../common/images/socials/twitter.svg';
import LinkedinIcon from '../../common/images/socials/linkedin.svg';
import InstagramIcon from '../../common/images/socials/instagram.svg';
import YelpIcon from '../../common/images/socials/yelp.svg';
import { useDispatch } from 'react-redux';
import {
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress
} from '@/explore/ducks/selectors';
import { Row } from 'react-aria-components';

type Props = {
  open: boolean;
  close: () => void;
  details?: DealerProfileType;
};

const SocialLinksEditModal = ({ open, close, details }: Props) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const dispatch = useDispatch();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const form: any = useForm<socialLinkType>({
    resolver: yupResolver(socialLinksSchema),
    defaultValues: initialValues,
    mode: 'onBlur'
  });
  const watchValues = form.watch();
  console.log('watch values', watchValues);

  const linksArray = useFieldArray({
    control: form.control,
    name: 'links'
  });

  const toggleStatus = async (index: number, value: boolean) => {
    const path = `links.${index}.status` as 'links.0.status';
    form.setValue(path, value);
    if (!value) {
      toggleIsSubmitDisabled();
    }
  };

  const handleSetInitialValues = () => {
    const links: socialLinkType['links'] = [];

    for (let i = 0; i <= initialValues.links.length - 1; i++) {
      // const obj = details?.businessDetails.socialProfiles[i];
      const current = initialValues.links[i]
      const found = details?.businessDetails.socialProfiles.find(row => row.label === current.name);
      if (found) {
        links.push({
          name: found.label,
          status: found.value.length > 0,
          link: found.value[0],
          icon: found.label,
          sortIndex: initialValues.links.find((link) => link.name === found.label)
            ?.sortIndex
        });
      } else {
        links.push(initialValues.links[i]); 
      }
      
    }

    links.sort((a, b) => {
      return (a.sortIndex ?? 0) - (b.sortIndex ?? 0);
    });
    console.log('links', links)
    form.setValue('links', links);
  };
  const toggleIsSubmitDisabled = async () => {
    const isValid = await form.trigger();
    setIsSubmitDisabled(!isValid);
  };

  const handleSubmit = async () => {
    const isValid = await form.trigger();
    if (!isValid) return;
    
    const payload = {
      google: getValueByName(socialLinksName.GOOGLE),
      facebook: getValueByName(socialLinksName.FACEBOOK),
      linkedin: getValueByName(socialLinksName.LINKEDIN),
      instagram: getValueByName(socialLinksName.INSTAGRAM),
      twitter: getValueByName(socialLinksName.TWITTER),
      yelp: getValueByName(socialLinksName.YELP),
      source: 'ffl360',
      name: 'social_links',
      license_key:details?.primaryInboundDetails.licenseKey ?? ""
    };
    
    console.log('triggering with payload', payload)
    dispatch(
      callToCreateDealerAction({
        socialLinksUpdatePayload: [payload]
      })
    );
  };

  const getValueByName = (name: socialLinksName) => {
    const values = form.getValues();
    const found = values.links.find((row: any) => row.name === name);
    return found?.status ? found?.link : null;
  };


  useEffect(() => {
    toggleIsSubmitDisabled();
  }, [watchValues]);

  useEffect(() => {
    if (open) {
      handleSetInitialValues();
    }
  }, [open]);

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      close()
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  return (
    <Modal closeOnOverlayClick={false} isOpen={open} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent
        className={`transfer-create-modal`}
        maxWidth={'534px'}
        maxHeight={'90vh'}
        scrollBehavior={'auto'}
      >
        <ModalHeader className="store-contact-details-edit-header">
          Edit Social Details
          <button className="transfer-create-modal__close-btn" onClick={close}>
            <img src="/images/ui/close.svg" />
          </button>
        </ModalHeader>
        <ModalBody className={'store-contact-details-edit-body'}>
          <Flex
            direction={'column'}
            padding={0}
            gap={3}
            borderBottom={'1px solid #D4D4D4'}
            paddingBottom={'20px'}
          >
            {linksArray.fields.map((field: any, index) => (
              <Card>
                <TextField
                  placeholder="Enter Link"
                  hideInput={!watchValues.links[index].status}
                  form={form}
                  extra={
                    <Switch
                      className={watchValues.links[index].status ? 'edit-social-details-green-toggle' : 'edit-social-details-red-toggle'}
                      colorScheme='#f00'
                      onChange={(e) => toggleStatus(index, e.target.checked)}
                      isChecked={watchValues.links[index].status}
                    />
                  }
                  name={`links.${index}.link`}
                  label={
                    <InputLabel
                      iconDisabled={!watchValues.links[index].status}
                      icon={getIcon(field.name as socialLinksName)}
                      label={getInitialValueByName(field.name as socialLinksName)?.label ?? ""}
                    />
                  }
                />
              </Card>
            ))}
          </Flex>
        </ModalBody>
        <ModalFooter className={`store-contact-details-edit-footer`}>
          <Button
            colorScheme="blue"
              onClick={close}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            fontSize={'16px'}
            marginRight="20px"
            height={'35px'}
            width={'100px'}
              isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            height={'35px'}
            width={'100px'}
            fontSize={'16px'}
            padding="8px 20px"
            onClick={handleSubmit}
            isDisabled={isSubmitDisabled}
            isLoading={isCreateDealerActionInprogress}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SocialLinksEditModal;

const InputLabel = ({
  icon,
  label,
  iconDisabled
}: {
  icon?: ReactNode;
  label: string;
  iconDisabled: boolean;
}) => {
  return (
    <Flex gap={3} align={'center'}>
      <Box opacity={iconDisabled ? 0.3 : 1}>{icon}</Box>
      <p>{label}</p>
    </Flex>
  );
};

const getIcon = (name: socialLinksName) => {
  switch (name) {
    case socialLinksName.GOOGLE:
      return <img src={GoogleIcon} />;
    case socialLinksName.INSTAGRAM:
      return <img src={InstagramIcon} />;
    case socialLinksName.TWITTER:
      return <img src={TwitterIcon} />;
    case socialLinksName.LINKEDIN:
      return <img src={LinkedinIcon} />;
    case socialLinksName.FACEBOOK:
      return <img src={FacebookIcon} />;
    case socialLinksName.GOOGLE:
      return <img src={GoogleIcon} />;
    case socialLinksName.YELP:
      return <img src={YelpIcon} />;
  }
};

const Card = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box background={'#FDFDFD'} className="contact-details-box">
      {children}
    </Box>
  );
};
